/** How long the browser has the file to start the download before the temporary address is let go. */
const REVOKE_AFTER_MS = 60 * 1000;

/**
 * Makes the browser save a file under the given name, as an attachment (nothing is opened in a tab).
 *
 * @param file the content
 * @param fileName the name to save it as
 */
export function downloadFile(file: Blob, fileName: string): void {
  const url = URL.createObjectURL(file);

  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  link.remove();

  setTimeout(() => URL.revokeObjectURL(url), REVOKE_AFTER_MS);
}
